<template>
    <Head :title="`${gradeTitle.title}課題｜${gym.title}`" />

    <BreezeAuthenticatedLayout>
      <main class="container">
        <div class="main project">
          <div class="c-header">
            <Link :href="`/gyms/${gym.slug}`">
              <img src="/images/icons/icon-chevron-left.svg" alt="back" class="c-header__back">
            </Link>
            <h2 class="c-header--h2">
              <span class="project_title_color" :style="{ backgroundColor: gradeTitle.color }"></span>
              {{ gradeTitle.title }}
            </h2>
          </div>

          <div class="mt-12">{{ gym.title }}</div>

          <div v-if="$page.props.flash.message" class="message">
            {{ $page.props.flash.message }}
          </div>

          <div class="pickupG_wrap">
            <div v-if="propertyCount === 0">
              <div class="pickupG_wrap_row">
                <div class="pickupG_wrap_row_project-name">
                  <div class="pickupG_wrap_row_project-name_title">課題がありません</div>
                </div>
              </div>
            </div>
            <!-- start v-for -->
            <div v-for="project in projects" :key="project.id" class="pickupG_wrap_row">
              <Link :href="`/projects/${project.id}`" class="pickupG_wrap_row_link" :class="{ cleared: arrStatus[project.id] == 'rp' || arrStatus[project.id] == 'flash' }">

                <div class="pickupG_wrap_row_project-name">
                  <div class="pickupG_wrap_row_project-name_title">{{ project.name }}</div>
                  <div class="pickupG_wrap_row_project-name_info">
                    {{ new_categories[project.category_id] }} / 
                    {{ new_walls[project.wall_id] }}：
                    WINNER {{ project.number_of_completed }}人
                  </div>
                  <div v-if="new Date(project.startdate) > new Date()" class="red bold">
                    【Owner】公開前：{{ project.startdate }}に公開
                  </div>
                </div>

                <!-- kawaii monsters -->
                <div v-if="$page.props.auth.user" class="pickupG_wrap_row_cleared">
                  <div v-if="arrStatus[project.id] == 'flash'" class="pickupG_wrap_row_cleared_status flash">
                    <img src="/images/icons/icon-flash.svg">
                  </div>
                  <div v-else-if="arrStatus[project.id] == 'rp'" class="pickupG_wrap_row_cleared_status rp">
                    <img src="/images/icons/icon-check.svg">
                  </div>
                  <div v-else class="pickupG_wrap_row_cleared_status monster">
                    <img :src="`/images/monster/${monsters[$page.props.auth.chara.level][project.id%3].name}.gif`">
                  </div>
                </div>

                <div v-if="project.image" class="pickupG_wrap_row_project-image">
                  <img :src="`${imgPath}thumb_${project.image}`">
                </div>
                <div v-else class="pickupG_wrap_row_project-image">
                  <img src="/images/common/no-image.jpg">
                </div>
              </Link>
              
            </div>
            <!-- end v-for -->
          </div>

          <!-- <div class="admin-area" v-if="auth.user && user.can.isAdmin"> -->
          <div class="admin-area" v-if="(auth.user && user.can.isAdmin) || (auth.user && user.can.isOwnerHigher && gym.users && gym.users.length > 0 && auth.user.id == gym.users[0].pivot.user_id)">

            <h3 class="admin-area_heading c-heading-h4">管理者エリア</h3>
            <div class="c-button-wrap">

              <Link :href="`/gyms/${gym.id}/edit`" class="c-button half">ジム情報編集</Link>
              <Link :href="`/projects/create/${gym.id}`" class="c-button half">課題を追加</Link>
            </div>

            <hr>
            
            <h3 class="c-heading-h4 underline">課題並び順</h3>
            <draggable v-model="projects" group="project" item-key="id" animation="200" @change="update">
            <template #item="{element}">
              <div class="c-list_block">
                <div class="c-list_block_title">
                  {{ element.name }}
                  <div v-if="new Date(element.startdate) > new Date()" class="red bold ml-4 small">
                    公開前：{{ element.startdate }}に公開
                  </div>
                </div>
                <div class="c-list_block_buttons">
                  <div class="c-list_block_operation_drag handle" handle=".handle"><img src="/images/icons/icon-arrow-up-down.png" alt="drag"></div>
                </div>
              </div>

            </template>
          </draggable>

          </div>

        </div>
        <Side />
      </main>
    </BreezeAuthenticatedLayout>
</template>

<script>
  import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
  import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
  import { Inertia } from '@inertiajs/inertia';
  import Side from '@/Shared/Side'
  import draggable from "vuedraggable";

  export default {
    components: {
      BreezeAuthenticatedLayout,
      Head,
      Link,
      draggable,
      Inertia,
      Side,
    },
    props: {
      gym: Object,
      projects: Object,
      auth: Object,
      user: Object,
      new_categories: Object,
      new_walls: Object,
      gradeTitle: Object,
      // uProjects: Object,
      arrStatus: Object,
      monsters: Object,
      imgPath: String
    },
    data() {
      return {
        propertyCount: 0
      };
    },
    methods: {
      update() {
        this.projects.map((project, index) => {
          project.order = index + 1;
        })
        axios.put('/projects/updateAll', {
          projects: this.projects,
          gym_id: this.gym.id
        }).then((response) => {
          // flash success message etc
        })
      },
      getPropertyCount() {
        this.propertyCount = Object.keys(this.projects).length;
      }
    },
    mounted() {
      this.getPropertyCount();
    }
  }
</script>
